import { sendNotification } from '@vtblife/block-kit-utils';
export function handleSendStepError(error) {
    var _a, _b;
    console.error(error);
    let type = 'error';
    let message = 'Сервис совершил непредвиденную ошибку, мы уже работаем над этим, попробуйте отослать данные позднее.';
    if (error.response.status >= 400 && error.response.status < 500) {
        type = 'warning';
        message =
            error.response.status == 400 && ((_a = error.response.data) === null || _a === void 0 ? void 0 : _a.message)
                ? (_b = error.response.data) === null || _b === void 0 ? void 0 : _b.message
                : 'Вы совершили некорректные действия, возможно, ввели некорректные данные.';
    }
    sendNotification({ message, type });
    console.error(error);
}
//# sourceMappingURL=handle-send-step-error.js.map